<div class="uploading-card">
  <div class="upload-icon">
    <div class="small-mountain"></div>
    <div class="big-mountain"></div>
  </div>
  <div class="footer">
    <ng-container *ngIf="uploadingState === uploadingStates.UPLOADING">
      <div class="spinner">
        <csa-progress-save-spinner [size]="20" [strokeWidth]="2"></csa-progress-save-spinner>
      </div>
      <div class="uploading-text">{{ 'csa.media.uploading' | translate }}</div>
    </ng-container>
    <ng-container *ngIf="uploadingState === uploadingStates.FAILED">
      <div class="circle">!</div>
      <div class="uploading-text">{{ 'csa.media.upload.failed' | translate }}</div>
      <div class="uploading-text underline" (click)="tryAgain()">{{ 'csa.media.upload.try.again' | translate }}</div>
    </ng-container>
  </div>
</div>
